import {Box, Typography} from "@mui/material";
import {IVersion} from "./Revisions";

interface IRevisionDifference {
    previous?: IVersion
    version: IVersion
}
export function RevisionDifference({previous, version}: IRevisionDifference) {
    const getBlocks = (version: IVersion) =>
        version.data.entities?.filter(entity =>
            entity.m_entity.m_components.length === 2 && entity.m_entity.m_components[1] === "Block")
            .map(entity => entity.m_text?.text || "") || [];
    const previousBlocks = previous ? getBlocks(previous) : [];
    const versionBlocks = getBlocks(version);
    const addedBlocks = versionBlocks.filter(blockName => ! previousBlocks.includes(blockName));
    const deletedBlocks = previousBlocks?.filter(blockName => ! versionBlocks.includes(blockName)) ?? [];

    return (
        <Box display="flex" flexDirection="column" width="100%">
            {!!(addedBlocks.length || deletedBlocks.length) &&
                <Box>
                    <Typography variant="h6">Blocks</Typography>
                    {addedBlocks?.map(blockName =>
                        <Box display="flex" flexGrow={1} key={blockName}>
                            <Typography sx={{flexGrow: 1}}><strong>Added</strong></Typography>
                            <Typography>{blockName}</Typography>
                        </Box>
                    )}
                    {deletedBlocks?.map(blockName =>
                        <Box display="flex" flexGrow={1} key={blockName}>
                            <Typography sx={{flexGrow: 1}}><strong>Deleted</strong></Typography>
                            <Typography>{blockName}</Typography>
                        </Box>
                    )}
                </Box>
            }
        </Box>
    );
}